/**
 * frameScheduler — rAF scheduling for the per-chat external stores.
 *
 * Shared by [ChunkBuffer](../stream/ChunkBuffer.ts) and
 * [StepStore](../steps/StepStore.ts), which batch their notifications the same
 * way: coalesce every mutation in a frame, notify once. The two had identical
 * private copies of this pair.
 *
 * `requestAnimationFrame` is absent in Node, where the `__verify` suites run, so
 * both fall back to a microtask. `-1` is the sentinel for "scheduled as a
 * microtask", which cannot be cancelled — the caller's `disposed` flag is what
 * makes that safe.
 */

/** Run `cb` on the next animation frame. Returns a handle for `cancelFrame`. */
export function scheduleFrame(cb: () => void): number {
  if (typeof requestAnimationFrame === 'function') {
    return requestAnimationFrame(cb);
  }
  queueMicrotask(cb);
  return -1;
}

/** Cancel a handle from `scheduleFrame`. A microtask fallback is a no-op. */
export function cancelFrame(handle: number): void {
  if (handle !== -1 && typeof cancelAnimationFrame === 'function') {
    cancelAnimationFrame(handle);
  }
}
